import {
  AfWhitelistState,
  AfWhitelistActionTypes,
  GET_AFWHITELIST_LIST,
  GET_AFWHITELIST_LIST_FULFILLED,
  GET_AFWHITELIST_PENDING,
  GET_AFWHITELIST_FULFILLED,
  SELECT_AFWHITELIST,
  CREATE_AFWHITELIST_PENDING,
  CREATE_AFWHITELIST_FULFILLED,
  DELETE_AFWHITELIST_FULFILLED,
  SET_AFWHITELIST_LOADING,
} from './afWhitelist.types';

export const initialState: AfWhitelistState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function afWhitelistReducer(
  state = initialState,
  action: AfWhitelistActionTypes,
): AfWhitelistState {
  switch (action.type) {
    case GET_AFWHITELIST_LIST:
      return {
        ...state,
        selected: [],
      };
    case GET_AFWHITELIST_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
      };
    case GET_AFWHITELIST_PENDING:
      return {
        ...state,
        single: null,
      };
    case GET_AFWHITELIST_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };
    case SELECT_AFWHITELIST:
      return {
        ...state,
        selected: action.payload || [],
      };
    case CREATE_AFWHITELIST_PENDING:
      return {
        ...state,
        createdId: null,
      };
    case CREATE_AFWHITELIST_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };
    case DELETE_AFWHITELIST_FULFILLED:
      return {
        ...state,
        selected: [],
      };
    case SET_AFWHITELIST_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };
    default:
      return state;
  }
}
